import { Component, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  standalone: false,
})
export class PageFooterComponent {
  @ContentChild('controlBarTemplate')
  public controlBarTemplate: TemplateRef<unknown>;
}
